var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('nuxt')],1)],1),_vm._v(" "),_c('span',{staticClass:"d-none"},[_vm._v("Commit: "+_vm._s(_vm.commitHash))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }